<template>
  <div class="cardFooterDetails">
    <div
      v-if="flowMeter.volumePerPulse || flowMeter.unitsOfMeasure"
      class="pulseInfo"
    >
      <span v-if="flowMeter.volumePerPulse">{{ this.$t('devices.flowMeters.volumePerPulse') }} : </span>
      <strong v-if="flowMeter.volumePerPulse">{{ flowMeter.volumePerPulse }}</strong>
      <strong v-if="flowMeter.unitsOfMeasure">
        {{ this.$t(`volumes.${flowMeter.unitsOfMeasure}`) }}
        <span v-if="flowMeter.volumePerPulse > 0">{{ this.$t('devices.flowMeters.pulse') }}</span>
      </strong>
    </div>
  </div>
</template>

<script>

export default {

    props: {
        flowMeter: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
<style scoped lang="scss">
@import '@/assets/styles/components/_analysisGrid.scss';
</style>
